// extracted by mini-css-extract-plugin
export default {"coverage-statement-fields-category":"coverage-statement-fields-category---vShBW"};